@if (showShell) {

  <div class="app-shell">

    <div

      class="nav-backdrop"

      [class.visible]="sideNavOpen"

      (click)="closeSideNav()"

      aria-hidden="true"

    ></div>



    <app-side-nav

      [isOpen]="sideNavOpen"

      (closeSideNav)="closeSideNav()"

    ></app-side-nav>



    <header class="mobile-topbar">

      <button

        type="button"

        class="menu-toggle"

        [class.active]="sideNavOpen"

        (click)="toggleSideNav()"

        [attr.aria-expanded]="sideNavOpen"

        aria-label="Toggle navigation"

      >

        <span class="bar"></span>

        <span class="bar"></span>

        <span class="bar"></span>

      </button>

      <div class="mobile-brand">
        <img src="/images/logo.png" alt="Unpluggit" class="mobile-logo" />
        <span>IMS</span>
      </div>

    </header>



    <main class="main-content">

      <router-outlet />

    </main>

  </div>

} @else {

  <router-outlet />

}


